"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Messaging = void 0;

var _messaging = require("./messaging.reducer");

var _messaging2 = _interopRequireDefault(require("./messaging.epics"));

var _PlaceholdersModal = _interopRequireDefault(require("./Placeholders/components/PlaceholdersModal/PlaceholdersModal"));

var _PlaceholdersButton = _interopRequireDefault(require("./Placeholders/components/PlaceholdersButton/PlaceholdersButton"));

var _PlaceholdersTextField = _interopRequireDefault(require("./Placeholders/components/PlaceholdersTextField/PlaceholdersTextField"));

var _TextWithPlaceholders = _interopRequireDefault(require("./Placeholders/components/TextWithPlaceholders/TextWithPlaceholders"));

var _usePlaceholders = require("./Placeholders/hooks/usePlaceholders/usePlaceholders");

var Messaging = {
  reducer: _messaging.messaging,
  epics: _messaging2.default,
  PlaceholdersModal: _PlaceholdersModal.default,
  PlaceholdersButton: _PlaceholdersButton.default,
  PlaceholdersTextField: _PlaceholdersTextField.default,
  TextWithPlaceholders: _TextWithPlaceholders.default,
  hooks: {
    usePlaceholders: _usePlaceholders.usePlaceholders
  }
};
exports.Messaging = Messaging;